export enum StatusType {
  BLIND = 'BLIND',
  DELETE = 'DELETE',
  NORMAL = 'NORMAL',
  REMOVE = 'REMOVE',
}

export enum ReviewAttachStatusType {
  BLIND = 'BLIND',
}
